import React, { useState } from "react";
import "./MultimediaHomeStyles.css";
import Shikhaa_Logo from "../../../Assets/Cover/Shikhaa_Logo.png";

import image1 from "../../../Assets/Multimedia/MultiHome/1.jpg";
import image2 from "../../../Assets/Multimedia/MultiHome/2.jpg";
import image3 from "../../../Assets/Multimedia/MultiHome/3.jpg";
import image4 from "../../../Assets/Multimedia/MultiHome/4.jpg";
import image5 from "../../../Assets/Multimedia/MultiHome/5.jpg";
import image6 from "../../../Assets/Multimedia/MultiHome/6.jpg";
import image7 from "../../../Assets/Multimedia/MultiHome/7.jpg";
import image8 from "../../../Assets/Multimedia/MultiHome/8.jpg";
import image9 from "../../../Assets/Multimedia/MultiHome/9.jpg";
import image10 from "../../../Assets/Multimedia/MultiHome/10.jpg";
import image11 from "../../../Assets/Multimedia/MultiHome/11.jpg";
import image12 from "../../../Assets/Multimedia/MultiHome/12.jpg";
import image13 from "../../../Assets/Multimedia/MultiHome/13.jpg";
import image14 from "../../../Assets/Multimedia/MultiHome/14.jpg";
import image15 from "../../../Assets/Multimedia/MultiHome/15.jpg";
import image16 from "../../../Assets/Multimedia/MultiHome/16.jpg";

const MultimediaHome = () => {
  const images = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openModal = (index) => {
    setIsModalOpen(true);
    setCurrentImageIndex(index);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length,
    );
  };

  return (
    <div className="Multimedia-container">
      <div className="Shikhaa_Multi_logo">
        <img id="Shikhaa-Const-logo" src={Shikhaa_Logo} alt="Shikhaa Logo" />
      </div>

      <h1>MULTIMEDIA</h1>
      <h2>POUSH MELA PHOTO GALLERY</h2>

      <div className="multimedia_gallery">
        {images.map((image, index) => (
          <div
            className="thumbnail"
            key={index}
            onClick={() => openModal(index)}
          >
            <img src={image} alt={`thumbnail-${index}`} />
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className="multi-modal">
          <button className="multi-close" onClick={closeModal}>
            ×
          </button>

          <button className="multi-arrow multi-prev" onClick={prevImage}>
            ❮
          </button>

          <img
            src={images[currentImageIndex]}
            alt={`modal-img-${currentImageIndex}`}
            className="multi-modal-image"
          />

          <button className="multi-arrow multi-next" onClick={nextImage}>
            ❯
          </button>
        </div>
      )}
    </div>
  );
};

export default MultimediaHome;
